<h2 mat-dialog-title>Finalize receipt</h2>
<mat-dialog-content class="mat-typography">
  <p>Finalizing the receipt disables adding new images. </p>
  <p>Do you want to proceed? </p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Finalize</button>
</mat-dialog-actions>
